import React, { FunctionComponent } from 'react';
import { FullScreenContent } from 'components/Layouts/FullScreenView/FullScreenContent';
import { Visualizer } from 'components/Player/Visualizer';
import { RecordingModel } from 'features/recordings/RecordingModel';
import { RecordingPlayer } from 'features/recordings/components/RecordingPlayer';

interface RecordingWrapperProps {
  recording: RecordingModel | null;
}

export const RecordingContent: FunctionComponent<RecordingWrapperProps> = ({
  recording
}) => {
  if (!recording) {
    return null;
  }

  return (
    <FullScreenContent
      centerColumn={<RecordingPlayer />}
      visualizer={<Visualizer />}
    />
  );
};
